import React from "react"
import PropTypes from "prop-types"
import { Box } from "@mui/material"

import MetricCard from "./MetricCard"
import { overviewCardsGridSx4 } from "./constants/overviewGrid"

const CollectionsSection = ({ data, isLoading }) => {
  const cards = (data?.cards ?? []).map(card => (
    <Box key={card.id ?? card.title} sx={{ minWidth: 0 }}>
      <MetricCard {...card} loading={isLoading} />
    </Box>
  ))

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={overviewCardsGridSx4}>{cards}</Box>
    </Box>
  )
}

CollectionsSection.propTypes = {
  data: PropTypes.shape({
    currency: PropTypes.string,
    cards: PropTypes.arrayOf(PropTypes.object),
  }),
  isLoading: PropTypes.bool.isRequired,
}

export default CollectionsSection
